import { Tooltip } from '@mantine/core'

import { contactSourceLabel } from 'src/graphql/types/contacts'

/**
 * Where a directory contact came from, as a small grey badge with the longer
 * explanation on hover. Shared by the picker's options and the employment
 * drawer's contacts block so a source reads the same in both.
 */
const ContactSourceBadge = ({ source }: { source?: string | null }) => {
  const config = contactSourceLabel(source)
  if (!config) return null

  return (
    <Tooltip label={config.tooltip} withArrow position="top">
      <span className="shrink-0 cursor-default rounded bg-doubleNickel-gray-100 px-1.5 py-0.5 text-[11px] font-medium text-doubleNickel-gray-500">
        {config.label}
      </span>
    </Tooltip>
  )
}

export default ContactSourceBadge
